module.exports = __webpack_public_path__ + "static/img/scene_4.ec877f8b.png";